export default "__VITE_ASSET__B2a5u3iI__"